// The segment API answers as the screens use them; each keeps the
// `coverage` of its read (uncovered ranges = incomplete figures, never a
// proven zero — Codex confirmation review 5).

export const toPreviewCount = (result) => ({
  count: result?.count ?? 0,
  coverage: result?.coverage ?? null,
});

export const toReachEstimate = (result) => ({
  reach: Number(result?.reach ?? 0),
  requests: Number(result?.requests ?? 0),
  windowLabel: result?.window?.label ?? null,
  coverage: result?.coverage ?? null,
});

export const toSegmentStatistics = (result) => ({
  vasts: result?.vasts ?? null,
  totalImpressions: result?.totalImpressions ?? null,
  coverage: result?.coverage ?? null,
});

// /statistics/totals for the audience cards; reach null = its read was
// refused (unknown, not 0).
export const toAudienceTotals = (data) => ({
  reach: data?.reach === undefined ? 0 : data.reach,
  reachUnavailable: data?.reachUnavailable ?? null,
  impressions: data?.impressions ?? 0,
  activeAudiences: data?.activeAudiences ?? 0,
  dataSources: data?.dataSources ?? 0,
  coverage: data?.coverage ?? null,
});
